import React from "react";
import { X, Sparkles, Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * BetaAdCard - House ad component for beta monetization
 * 
 * Rules:
 * - Shows after every 10 successful translations
 * - Capped at 3 ads per session
 * - NOT shown on: Login, Legal pages, Emergency flows
 */
const BetaAdCard = ({ onDismiss }) => {
  const navigate = useNavigate();

  const handleGoPro = () => {
    onDismiss?.();
    navigate('/pricing');
  };

  const handleJoinBeta = () => {
    onDismiss?.();
    navigate('/beta');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
        {/* Dismiss Button */}
        <button
          onClick={onDismiss}
          className="absolute top-3 right-3 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors z-10"
          aria-label="Dismiss"
          data-testid="ad-dismiss"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Gradient Header */}
        <div className="bg-gradient-to-r from-[#0EA5E9] to-[#10b981] p-6 pb-8">
          <div className="flex items-center gap-2 text-white/80 text-sm font-medium mb-2">
            <Sparkles className="w-4 h-4" />
            <span>Support PassportTalk Beta</span>
          </div>
          <h3 className="text-xl font-bold text-white">
            💙 Help Us Grow
          </h3>
        </div>

        {/* Content */}
        <div className="p-6 -mt-4">
          <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4 mb-6">
            <p className="text-slate-600 text-sm leading-relaxed">
              Ads help fund <strong>dialect accuracy</strong>, <strong>WhatsApp features</strong>, and keep PassportTalk free during beta.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleGoPro}
              className="w-full py-3 px-4 bg-gradient-to-r from-[#0EA5E9] to-[#06b6d4] text-white font-semibold rounded-xl hover:shadow-lg hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
              data-testid="ad-go-pro"
            >
              <Sparkles className="w-4 h-4" />
              Go Pro (No Ads)
            </button>
            
            <button
              onClick={handleJoinBeta}
              className="w-full py-3 px-4 bg-slate-100 text-slate-700 font-semibold rounded-xl hover:bg-slate-200 transition-all flex items-center justify-center gap-2"
              data-testid="ad-join-beta"
            >
              <Bell className="w-4 h-4" />
              Join Beta Updates
            </button>
          </div>

          {/* Fine Print */}
          <p className="mt-4 text-xs text-slate-400 text-center">
            Beta users help shape the product
          </p>
        </div>
      </div>
    </div>
  );
};

export default BetaAdCard;
